import { AvatarProfileSizeType } from '../../../../../../components/avatarProfile/types/avatarProfileSizeType';
import { AvatarProfileStateType } from '../../../../../../components/avatarProfile/types/avatarProfileStateType';
import { AvatarProfileVariantType } from '../../../../../../components/avatarProfile/types/avatarProfileVariantType';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../text/variants';
const buildCommonEmptyProps = (FOUNDATIONS) => ({
    rootContainer: {
        display: 'flex',
        flex_direction: 'column',
        align_items: 'center',
        gap: FOUNDATIONS.spacing_150,
    },
    avatarWrapper: {
        position: 'relative',
    },
    avatarContainer: {
        display: 'flex',
        justify_content: 'center',
        align_items: 'center',
        border_radius: FOUNDATIONS.radius_1000,
        border_style: 'solid',
        border_width: FOUNDATIONS.border_50,
        border_color: FOUNDATIONS.color_comp_resources_avatarprofile_empty_default_border,
        background_color: FOUNDATIONS.color_comp_resources_avatarprofile_empty_default_bg,
        cursor: 'pointer',
    },
    avatarContent: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        display: 'flex',
        align_items: 'center',
        justify_content: 'center',
        pointer_events: 'none',
    },
    icon: {
        color: FOUNDATIONS.color_comp_resources_avatarprofile_empty_default_icon,
    },
    labelContainer: {
        width: '4.375rem',
    },
    label: {
        font_variant: TextVariantType.FONT_PARAGRAPH_500,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_neutral_font_50,
        text_align: 'center',
    },
});
const buildCommonEmptyExtraExtraSmallProps = (FOUNDATIONS) => {
    const commonEmptyProps = buildCommonEmptyProps(FOUNDATIONS);
    return {
        ...commonEmptyProps,
        avatarContainer: {
            ...commonEmptyProps.avatarContainer,
            width: FOUNDATIONS.size_300,
            height: FOUNDATIONS.size_300,
        },
        icon: {
            ...commonEmptyProps.icon,
            width: FOUNDATIONS.size_200,
            height: FOUNDATIONS.size_200,
        },
    };
};
const buildCommonEmptyExtraSmallProps = (FOUNDATIONS) => {
    const commonEmptyProps = buildCommonEmptyProps(FOUNDATIONS);
    return {
        ...commonEmptyProps,
        avatarContainer: {
            ...commonEmptyProps.avatarContainer,
            width: FOUNDATIONS.size_400,
            height: FOUNDATIONS.size_400,
        },
        icon: {
            ...commonEmptyProps.icon,
            width: FOUNDATIONS.size_300,
            height: FOUNDATIONS.size_300,
        },
    };
};
const buildCommonEmptySmallProps = (FOUNDATIONS) => {
    const commonEmptyProps = buildCommonEmptyProps(FOUNDATIONS);
    return {
        ...commonEmptyProps,
        avatarContainer: {
            ...commonEmptyProps.avatarContainer,
            width: '3rem',
            height: '3rem',
        },
        icon: {
            ...commonEmptyProps.icon,
            width: FOUNDATIONS.size_350,
            height: FOUNDATIONS.size_350,
        },
    };
};
const buildCommonEmptyMediumProps = (FOUNDATIONS) => {
    const commonEmptyProps = buildCommonEmptyProps(FOUNDATIONS);
    return {
        ...commonEmptyProps,
        avatarContainer: {
            ...commonEmptyProps.avatarContainer,
            width: '3.5rem',
            height: '3.5rem',
        },
        icon: {
            ...commonEmptyProps.icon,
            width: FOUNDATIONS.size_350,
            height: FOUNDATIONS.size_350,
        },
    };
};
const buildCommonEmptyLargeProps = (FOUNDATIONS) => {
    const commonEmptyProps = buildCommonEmptyProps(FOUNDATIONS);
    return {
        ...commonEmptyProps,
        avatarContainer: {
            ...commonEmptyProps.avatarContainer,
            width: '4rem',
            height: '4rem',
        },
        icon: {
            ...commonEmptyProps.icon,
            width: FOUNDATIONS.size_400,
            height: FOUNDATIONS.size_400,
        },
    };
};
const buildCommonEmptyExtraExtraLargeProps = (FOUNDATIONS) => {
    const commonEmptyProps = buildCommonEmptyProps(FOUNDATIONS);
    return {
        ...commonEmptyProps,
        avatarContainer: {
            ...commonEmptyProps.avatarContainer,
            width: FOUNDATIONS.size_1089,
            height: FOUNDATIONS.size_1089,
        },
        icon: {
            ...commonEmptyProps.icon,
            width: FOUNDATIONS.size_750,
            height: FOUNDATIONS.size_750,
        },
    };
};
export const getEmptyStyles = (FOUNDATIONS, FONT) => {
    const commonEmptyExtraExtraSmallProps = buildCommonEmptyExtraExtraSmallProps(FOUNDATIONS);
    const commonEmptyExtraSmallProps = buildCommonEmptyExtraSmallProps(FOUNDATIONS);
    const commonEmptySmallProps = buildCommonEmptySmallProps(FOUNDATIONS);
    const commonEmptyMediumProps = buildCommonEmptyMediumProps(FOUNDATIONS);
    const commonEmptyLargeProps = buildCommonEmptyLargeProps(FOUNDATIONS);
    const commonEmptyExtraExtraLargeProps = buildCommonEmptyExtraExtraLargeProps(FOUNDATIONS);
    return {
        [AvatarProfileVariantType.EMPTY]: {
            [AvatarProfileSizeType.EXTRA_EXTRA_SMALL]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonEmptyExtraExtraSmallProps,
                },
            },
            [AvatarProfileSizeType.EXTRA_SMALL]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonEmptyExtraSmallProps,
                },
            },
            [AvatarProfileSizeType.SMALL]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonEmptySmallProps,
                },
            },
            [AvatarProfileSizeType.MEDIUM]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonEmptyMediumProps,
                },
            },
            [AvatarProfileSizeType.LARGE]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonEmptyLargeProps,
                },
            },
            [AvatarProfileSizeType.EXTRA_EXTRA_LARGE]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonEmptyExtraExtraLargeProps,
                },
            },
        },
    };
};
//# sourceMappingURL=empty.js.map